interface KeyboardShortcut {
  key: string;
  description: string;
  condition?: string;
}

const shortcuts: KeyboardShortcut[] = [
  { key: '↑/↓', description: 'Navigate rows' },
  { key: 'Shift + ↑/↓', description: 'Select while navigating' },
  { key: 'Enter', description: 'Open selected row' },
  { key: 'Space', description: 'Select/deselect current row' },
  {
    key: 'B',
    description: 'Bulk edit selected items',
    condition: 'when items selected',
  },
  { key: 'C', description: 'Column visibility/configuration' },
  { key: 'S', description: 'Sort options' },
  { key: 'N', description: 'Create new item' },
];

export function TableKeyboardShortcutsList() {
  return (
    <div className="space-y-3">
      <div className="space-y-1">
        <h4 className="text-sm font-semibold">Keyboard Shortcuts</h4>
        <p className="text-muted-foreground text-xs">
          Navigate and interact with the table using your keyboard
        </p>
      </div>
      <div className="space-y-1">
        {shortcuts.map((shortcut, index) => (
          <div
            key={index}
            className="flex items-start justify-between gap-2 text-sm"
          >
            <kbd className="bg-muted text-muted-foreground rounded border px-2 py-0.5 font-mono text-xs">
              {shortcut.key}
            </kbd>
            <span className="text-foreground flex-1 text-xs">
              {shortcut.description}
              {shortcut.condition && (
                <span className="text-muted-foreground italic">
                  {' '}
                  ({shortcut.condition})
                </span>
              )}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
